import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const firebaseService = {
  async upload_file(token, file) {
    const uri = API_ROUTES.FIREBASE.UPLOAD_FILE;

    let formData;

    if (file instanceof FormData) {
      formData = file;
    } else if (file instanceof File) {
      formData = new FormData();
      formData.append("file", file);
    } else {
      throw new Error("upload_file expects File or FormData");
    }

    const res = await https.post(uri, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  },

  async delete_file(token, url) {
    if (!url || typeof url !== "string") {
      throw new Error("delete_file expects a valid file URL");
    }

    const uri = API_ROUTES.FIREBASE.DELETE_FILE;

    return https.post(
      uri,
      { url },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};
